module.exports = __webpack_public_path__ + "static/48-39989b37509238cd6ba42a9440c068ce.png";